import React from "react";
import clsx from "clsx";
import Tabs from "@mui/material/Tabs";

import * as strings from "../../../strings";

import Text from "../../common/Text/Text";
import MenuTrigger from "../MenuTrigger/MenuTrigger";
import MenuDropdown from "../MenuDropdown/MenuDropdown";
import MenuBarTab from "./sub-components/MenuBarTab";
import { link } from "../../../lib/util/NavigationUtils";
import { sendEvent, TrackingContext } from "../../../lib/util/AnalyticsUtils";

export default class MenuBar extends React.PureComponent {
	ref = React.createRef();
	static contextType = TrackingContext;

	constructor(props) {
		super(props);

		this.state = {
			currentSelected: props.defaultSelected || null,
		};
	}

	handleChange = (e, value) => {
		const { onSelect, routes } = this.props;
		const routeIndex = routes.findIndex((route) => route.id === value);
		const route = routes[routeIndex];

		this.setCurrentSelected(route);

		route.index = routeIndex;

		if (onSelect) {
			onSelect(route);
		}

		if (!route.noRedirect && route.pathName) {
			link(route.pathName, e);
		} else if (e) {
			e.stopPropagation();
			e.preventDefault();
		}

		sendEvent({
			eventCategory: `MenuBar - ${route.id}`,
			eventAction: "click",
			eventLabel: this.context,
			mixpanelProperties: {
				name: "Menu Bar Click",
				Context: this.context,
				Item: route.id,
			},
		});
	};

	componentDidUpdate(prevProps) {
		if ((prevProps.routes || []).length !== (this.props.routes || []).length) {
			this.forceUpdate();
		}
	}

	setCurrentSelected = (route) => {
		this.setState({ currentSelected: route?.id });
	};

	collectRef = (ref) => {
		if (ref) {
			this.ref.current = ref;
		}
	};

	render() {
		const {
			routes,
			className,
			selected,
			superscriptIcons,
			invert,
			onFilterItem,
			onRenderItem,
			fullWidth,
			user,
			collapse,
			loading,
		} = this.props;
		let { currentSelected } = this.state;

		currentSelected = selected === undefined ? currentSelected : selected;

		const dynamicTabValue = () => {
			if (collapse) {
				return routes.slice(0, 3).find((route) => route.id === currentSelected)
					? currentSelected
					: false;
			}
			return currentSelected;
		};

		return (
			<>
				<Tabs
					variant={fullWidth ? "fullWidth" : "standard"}
					value={dynamicTabValue()}
					onChange={this.handleChange}
					className={clsx(
						"MenuBar",
						className,
						invert && "--invert",
						fullWidth && "--fullWidth",
					)}
				>
					{routes.slice(0, collapse ? 3 : routes.length).map((item, index) => {
						const _superscriptIcon =
							typeof superscriptIcons !== "undefined"
								? superscriptIcons[index]
								: null;

						return (
							<MenuBarTab
								index={index}
								item={item}
								value={item.id}
								key={item.id}
								href={item.pathName}
								disabled={item.disabled}
								selected={currentSelected === item.id}
								onFilterItem={onFilterItem}
								onRenderItem={onRenderItem}
								user={user}
								loading={loading}
							>
								{_superscriptIcon}
							</MenuBarTab>
						);
					})}
				</Tabs>
				{collapse && (
					<TrackingContext.Provider
						value={{
							ga: "More Dropdown",
							mixpanel: {
								name: "More Dropdown",
								Context: this.context,
							},
						}}
					>
						<MenuDropdown
							items={routes.slice(3, routes.length)}
							usePortal={true}
							overlay={true}
							selected={currentSelected || null}
							className={"MenuItemsDropdown"}
						>
							<MenuTrigger className={"MenuBar__more-dropdown"}>
								<Text tag={"p"}>{strings.MISC_MORE}</Text>
							</MenuTrigger>
						</MenuDropdown>
					</TrackingContext.Provider>
				)}
			</>
		);
	}
}
